var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndustryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 14.1667H19.8334C20.7668 14.1667 21.2335 14.1667 21.5901 14.3483C21.9037 14.5081 22.1586 14.7631 22.3184 15.0767C22.5001 15.4332 22.5001 15.8999 22.5001 16.8333V22.5M15.8334 22.5V10.1667C15.8334 9.23325 15.8334 8.76654 15.6518 8.41002C15.492 8.09641 15.237 7.84144 14.9234 7.68166C14.5669 7.5 14.1002 7.5 13.1667 7.5H10.1667C9.23333 7.5 8.76662 7.5 8.4101 7.68166C8.09649 7.84144 7.84153 8.09641 7.68174 8.41002C7.50008 8.76654 7.50008 9.23325 7.50008 10.1667V22.5M23.3334 22.5H6.66675M10.4167 10.8333H12.9167M10.4167 14.1667H12.9167M10.4167 17.5H12.9167",
    stroke: "#575756",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryIcon);
export default __webpack_public_path__ + "static/media/IndustryIcon.8bba5e6cb76ee682ffbf82e2ac8d5b68.svg";
export { ForwardRef as ReactComponent };